'use strict';
define(['jquery'], function ($) {
    function OverviewController($scope, $rootScope, $state, AuthService, FavIconService, $timeout, $translate) {
        var vm = $scope;
        vm.isCurrentTab = $state.$current == 'app.seochecker.results.overview';
        vm.getFavIcon = FavIconService.get;
        vm.overviewCategories = [];
        vm.overviewSummary = {
            passed: 0,
            failed: 0,
            total: 0
        };

        $scope.authenticated = AuthService.isAuthenticated();
        $scope.chromeExtension = window.location.href.indexOf('chrome_extension');
        $scope.userInfo = JSON.parse(localStorage.getItem('userInfo'));

        if ($scope.chromeExtension != -1) {
            localStorage.setItem('chrome-extension', 'true');
        }

        $scope.openReportDialog = function () {
            $timeout(function () {
                $(document.querySelector('#report-pdf-button')).click();
            });
        }

        $scope.domainToAnalyze = $scope.analysis.url.replace(/(^\w+:|^)\/\//, '').split('/')[0];
        $scope.restOfUrl = $scope.analysis.url.replace(/(^\w+:|^)\/\//, '').replace($scope.domainToAnalyze, '');

        vm.overviewVerdict = function() {
            var score = Number(vm.score) || 0;
            if (score >= 90) {
                return $translate.instant('seochecker.verdictExcellent');
            }
            if (score >= 76) {
                return $translate.instant('seochecker.great');
            }
            if (score >= 60) {
                return $translate.instant('seochecker.good');
            }
            return $translate.instant('seochecker.verdictPoor');
        };

        vm.categoryScoreStyle = function(category) {
            var score = Math.max(0, Math.min(100, Number(category.score) || 0));
            return {
                background: 'conic-gradient(' + category.color + ' ' + score + '%, ' +
                    'var(--sto-color-surface-muted) ' + score + '%)'
            };
        };

        function buildCategoryCards() {
            var performance = vm.performance || {};
            var mobile = performance.mobile || {};
            var desktop = performance.desktop || {};
            var aeo = vm.aeo || {};
            var categories = [
                {
                    id: 'structure',
                    title: 'seochecker.base',
                    description: 'seochecker.overview.category.structure',
                    icon: 'ti-file-search',
                    state: 'app.seochecker.results.structure',
                    data: vm.base
                },
                {
                    id: 'content',
                    title: 'seochecker.content',
                    description: 'seochecker.overview.category.content',
                    icon: 'ti-file-text',
                    state: 'app.seochecker.results.content',
                    data: vm.content
                },
                {
                    id: 'performance',
                    title: 'seochecker.performance',
                    description: 'seochecker.overview.category.performance',
                    icon: 'ti-gauge',
                    state: 'app.seochecker.results.speed',
                    score: averageScores([mobile.score, desktop.score]),
                    exams: collectExams(mobile, 'Mobile').concat(collectExams(desktop, 'Desktop'))
                },
                {
                    id: 'social',
                    title: 'seochecker.social',
                    description: 'seochecker.overview.category.social',
                    icon: 'ti-share',
                    state: 'app.seochecker.results.social',
                    data: vm.social
                },
                {
                    id: 'aeo',
                    title: 'seochecker.seoGeo',
                    description: 'seochecker.overview.category.aeo',
                    icon: 'ti-sparkles',
                    state: 'app.seochecker.results.aeo',
                    score: Number((aeo.summary && aeo.summary.score) || aeo.score) || 0,
                    exams: collectExams(aeo, '')
                }
            ];

            categories.forEach(function(category) {
                if (!category.exams) {
                    category.exams = collectExams(category.data, '');
                }
                if (category.score === undefined || category.score === null) {
                    category.score = Number(category.data && category.data.score) || 0;
                }
                category.score = Math.round(Number(category.score) || 0);
                category.passedExams = category.exams.filter(function(exam) {
                    return exam.passed;
                });
                category.failedExams = category.exams.filter(function(exam) {
                    return !exam.passed;
                });
                category.passed = category.passedExams.length;
                category.failed = category.failedExams.length;
                category.total = category.exams.length;
                category.color = category.score >= 75
                    ? 'var(--sto-color-success)'
                    : (category.score >= 50 ? 'var(--sto-color-warning)' : 'var(--sto-color-critical)');
                category.exams.sort(function(a, b) {
                    return Number(a.passed) - Number(b.passed) || a.score - b.score;
                });
            });

            vm.overviewCategories = categories;
            vm.overviewSummary = categories.reduce(function(total, category) {
                total.passed += category.passed;
                total.failed += category.failed;
                total.total += category.total;
                return total;
            }, {
                passed: 0,
                failed: 0,
                total: 0
            });
        }

        function collectExams(group, suffix) {
            var exams = [];
            var source = group && group.exams ? group.exams : {};

            Object.keys(source).forEach(function(key) {
                var exam = source[key] || {};
                var score = Math.round(Number(exam.score) || 0);
                exams.push({
                    id: suffix ? suffix + '-' + key : key,
                    title: exam.title || key,
                    source: suffix,
                    score: score,
                    passed: score >= 70
                });
            });

            return exams;
        }

        function averageScores(scores) {
            var validScores = scores.map(Number).filter(function(score) {
                return !isNaN(score);
            });
            if (!validScores.length) {
                return 0;
            }
            return validScores.reduce(function(sum, score) {
                return sum + score;
            }, 0) / validScores.length;
        }

        $scope.$watchGroup(['base', 'content', 'performance', 'social', 'aeo', 'score'], buildCategoryCards);
        $rootScope.$on('languageChanged', buildCategoryCards);
    }

    OverviewController.$inject = ['$scope', '$rootScope', '$state', 'AuthService', 'FavIconService', '$timeout', '$translate'];
    return OverviewController;
});
